import { LngLatBounds, LngLat } from 'maplibre-gl'
import type { Slap, ObjectiveId, Objective, ObjectiveGroup, Board, ExpandedSlap } from '../utils/Primitives';
import { getPlaceGroupBounds } from '../places/Places';
import { MutableRefObject } from 'react';
import { lookupExpandedSlap } from '../slaps/Slaps';


const staticObjectives = (): ObjectiveGroup => {
    const nyc_m_places = {
        7080610075: null, // Bowling Green
        7080611099: null,
        7080610079: null,
        7080611103: null,
        7147618591: null,
        7147619615: null,
        7147620639: null,
        7147618595: null,
        7080611107: null,
        7147619619: null, // Tompkins Square
        7147620643: null,
        7080611111: null,
        7147618599: null, // Union Square
        7147619623: null,
        7147620647: null,
        7080611115: null,
        7147618603: null,
        7147619627: null,
        7147620651: null,
        7080611119: null,
        7147618607: null,
        7147619631: null,
        7147620655: null,
        7147621679: null,
        7147618611: null,
        7147619635: null,
        7147620659: null,
        7147621683: null,
        7147622707: null,
        7147619639: null,
        7147620663: null,
        7147621687: null,
        7147622711: null,
        7147623735: null,
        7147619643: null,
        7147620667: null,
        7147621691: null,
        7147622715: null,
        7147623739: null,
        7147620671: null,
        7147621695: null,
        7147622719: null,
        7147623743: null,
        7147621703: null,
        7147624767: null,
        7147621699: null,
        7147622723: null,
        7147623747: null,
        7147624771: null,
        7147622727: null,
        7147623751: null,
        7147624775: null,
        7147622731: null,
        7147623755: null,
        7147624779: null,
        7147623759: null,
        7147624783: null,
        7147623763: null,
        7147624787: null,
        7147624791: null,
        7147624795: null,
        7147625815: null,
        7147625819: null,
        7147626843: null,
        7147625823: null, // Inwood Hill Park
    }

    const nyc_m_bounds =  getPlaceGroupBounds(nyc_m_places)
    if (!nyc_m_bounds) {
        return {}
    }

    const objectives: ObjectiveGroup =  {
        1: {
            id: 1,
            name: "Capture The Flag",
            slaps: [],
            docPath: '/doc/objectives/capture-the-flag',
            description: "Slap a new place to capture the flag.",
            address: process.env.NEXT_PUBLIC_FLAG_OBJECTIVE_ADDRESS || "0x0000000000000000000000000000000000000000",
            priceDesc: "50 DEGEN",
        },
        2: {
            id: 2,
            name: '$NYC',
            bounds: nyc_m_bounds,
            places: nyc_m_places,
            docPath: '/doc/objectives/nyc',
            slaps: [],
            description: "Slap to earn $NYC",
            address: process.env.NEXT_PUBLIC_NYC_OBJECTIVE_ADDRESS || "0x0000000000000000000000000000000000000000",
            priceDesc: "100 DEGEN / slap",
        },

    }



    return objectives
}

export function initObjectiveStore(boardRef: MutableRefObject<Board>) {
    if (!boardRef.current) return;
    const objectives = staticObjectives()
    boardRef.current.objectiveStore = objectives
}

export function getObjectives(props: {boardRef: MutableRefObject<Board>}): ObjectiveGroup {
    const { boardRef } = props
    if (!boardRef.current) return {};
    // todo limit to searched for objectives
    return boardRef.current.objectiveStore
}

export function getObjective(props: {
    boardRef: MutableRefObject<Board>,
    objectiveId: ObjectiveId
}): Objective | null {
    const { boardRef, objectiveId } = props
    if (!boardRef.current) return null;
    const objectives = boardRef.current.objectiveStore
    return objectives[objectiveId] || null
}

export function writeSlapToObjectives(props: {
    boardRef: MutableRefObject<Board>,
    slap: Slap
}): void {
    const { boardRef, slap } = props
    if (!boardRef.current) return;
    const objectives = boardRef.current.objectiveStore

    if (!slap.objectiveIds) {
        return;
    }

    slap.objectiveIds.forEach(objectiveId => {
        const objective = objectives[objectiveId];
        if (objective && 'slaps' in objective) {
            if (!Array.isArray(objective.slaps)) {
                objective.slaps = [];
            }
            objective.slaps.unshift(slap.id);
        }
    });
}

export function getObjectiveExpandedSlaps(props: {
    boardRef: MutableRefObject<Board>,
    objectiveId: ObjectiveId
}): ExpandedSlap[] {
    const { boardRef, objectiveId } = props;
    const objective = getObjective({ boardRef, objectiveId });
    if (!objective || !objective.slaps) {
        return [];
    }

    const SLAP_LIMIT = 25;
    const recentSlapIds = objective.slaps.slice(0, SLAP_LIMIT);

    return recentSlapIds
        .map(slapId => lookupExpandedSlap({ boardRef, slapId }))
        .filter((slap): slap is ExpandedSlap => slap !== null);
}
